<template>
  <CCard>
    <CCardBody>
      <!-- Filtros para tabela e cards -->
      <CSelect
        :value.sync="paramsFilter.paramsMes"
        :options="arrMesesAno"
        v-model="paramsFilter.paramsMes"
        placeholder="Filtrar por mês"
        prepend="Meses"
        ref="meses do ano"
        @change="filtrarDadosKpis()"
      >
        <template #append-content>
          <CIcon name="cil-badge" />
        </template>
      </CSelect>
      <CSelect
        :value.sync="paramsFilter.paramsAno"
        :options="arrAnosRegistrados"
        v-model="paramsFilter.paramsAno"
        placeholder="Filtrar por ano"
        prepend="Ano"
        ref="anos registrados"
        @change="filtrarDadosKpis()"
      >
        <template #append-content>
          <CIcon name="cil-badge" />
        </template>
      </CSelect>
      <CSelect
        :value.sync="paramsFilter.paramsConvenio"
        :options="arrConvenios"
        v-model="paramsFilter.paramsConvenio"
        placeholder="Filtrar por convênio"
        prepend="Convênios"
        ref="Convênios"
        @change="filtrarDadosKpis()"
      >
        <template #append-content>
          <CIcon name="cil-badge" />
        </template>
      </CSelect>
      <CSelect
        :value.sync="paramsFilter.paramsProfissional"
        :options="arrProfissionais"
        v-model="paramsFilter.paramsProfissional"
        placeholder="Filtrar por profissionais"
        prepend="Profissionais"
        ref="Profissionais"
        @change="filtrarDadosKpis()"
      >
        <template #append-content>
          <CIcon name="cil-badge" />
        </template>
      </CSelect>
    </CCardBody>
    <!-- Tabela e Cards -->
    <CCardBody class="card-body">
      <CRow>
        <div class="div_cards">
          <div class="div-cards-value-evolution">
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Valor Total
              </p>
              <p class="extra-info-title">
                {{ arrCardsKpis.total_valor }}
              </p>
            </fieldset>
          </div>
          <div class="div-cards-value-evolution">
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Nº Atendimentos
              </p>
              <p class="extra-info-title">
                {{ arrCardsKpis.total_atendimentos }}
              </p>
            </fieldset>
          </div>
          <div class="div-cards-value-evolution">
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Ticket Médio
              </p>
              <p class="extra-info-title">
                {{ arrCardsKpis.ticket_medio }}
              </p>
            </fieldset>
          </div>
          <div class="div-cards-value-evolution">
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Valor Repasse
              </p>
              <p class="extra-info-title">
                {{ arrCardsKpis.valor_repasse }}
              </p>
            </fieldset>
          </div>
        </div>
      </CRow>

      <CDataTable
        :items="arrFieldsKpis"
        :fields="fieldsKpis"
        :noItemsView="not_found"
        column-filter
        hover
        searching
        sorter
        small
        :fixed="fixed"
        :items-per-page="12"
        :dark="dark"
        pagination
      >
      </CDataTable>
    </CCardBody>
  </CCard>
</template>
<script>
export default {
  name: "kpis",
  data() {
    return {
      not_found: {
        noItems: "Nenhum registro encontrado",
      },
      checkOptions: false,
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,

      fieldsKpis: [
        { key: "mes", label: "Mês", _style: "min-width:200px" },

        {
          key: "clientes_atendidos",
          label: "Clientes Atendidos",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "cancelamentos",
          label: "Cancelamentos",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "taxa_cancelamento",
          label: "Taxa de cancelamento",
          _style: "min-width:40px;",
          sorter: false,
          filter: false,
        },
      ],
      arrFieldsKpis: [],
      arrCardsKpis: [],

      arrMesesAno: [
        { label: "Todos", value: 0 },
        { label: "Janeiro", value: 1 },
        { label: "Fevereiro", value: 2 },
        { label: "Março", value: 3 },
        { label: "Abril", value: 4 },
        { label: "Maio", value: 5 },
        { label: "Junho", value: 6 },
        { label: "Julho", value: 7 },
        { label: "Agosto", value: 8 },
        { label: "Setembro", value: 9 },
        { label: "Outubro", value: 10 },
        { label: "Novembro", value: 11 },
        { label: "Dezembro", value: 12 },
      ],
      arrAnosRegistrados: [],
      arrConvenios: [{ label: "Todos", value: 0 }],
      arrProfissionais: [{ label: "Todos", value: 0 }],
      paramsFilter: {
        paramsMes: "",
        paramsAno: "",
        paramsConvenio: "",
        paramsProfissional: "",
      },
      btn_ver: false,
      count: 0,
    };
  },
  methods: {
    carregarDadosCards() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-dados-kpis-gerais`)
        .then((res) => res.json())
        .then((res) => {
          this.arrCardsKpis = res[0];
          consoloe.log({ arrCardsKpis: this.arrCardsKpis })
          this.paramsFilter.paramsAno = res[0].ano;
          this.paramsFilter.paramsMes = parseInt(res[0].mes);
        });
    },
    carregarDadosTabelaKpi() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-tabela-kpis-gerais`)
        .then((res) => res.json())
        .then((res) => {
          console.log({ res })
          this.arrFieldsKpis = res
          this.arrFieldsKpis.forEach((x)=>{
            x.taxa_cancelamento = parseFloat(x.taxa_cancelamento * 100).toFixed(2)
            if(x.taxa_cancelamento == 0.00){
              x.taxa_cancelamento = 0
            }
            x.taxa_cancelamento = `${x.taxa_cancelamento} %` 
          })
        });
    },
    carregarAnosRegistrados() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-anos-registrados`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            this.arrAnosRegistrados.push(elem.ano);
          });
        });
    },
    carregarConvenios() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-convenios`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            this.arrConvenios.push(elem.convenios);
          });
        });
    },
    carregarProfissionais() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-profissionais`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            this.arrProfissionais.push(elem.profissional);
          });
        });
    },
    filtrarDadosKpis() {
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}filtrar-kpis`, {
          params: this.paramsFilter,
        })
        .then((res) => res.json())
        .then((res) => {
          this.arrCardsKpis = res[0];
          this.arrCardsKpis.ticket_medio = parseFloat(this.arrCardsKpis.total_valor/this.arrCardsKpis.total_atendimentos).toFixed(2).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
          // this.arrCardsKpis.ticket_medio  = this.arrCardsKpis.ticket_medio .toLocaleString("pt-br", {
          //         style: "currency",
          //         currency: "BRL",
          //       })
          this.arrCardsKpis.valor_repasse = this.arrCardsKpis.valor_repasse.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
          this.arrCardsKpis.total_valor = this.arrCardsKpis.total_valor.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
        });
    },
  },
  mounted() {
   // this.carregarDadosCards();
    this.filtrarDadosKpis()
    this.carregarDadosTabelaKpi();
    this.carregarAnosRegistrados();
    this.carregarConvenios();
    this.carregarProfissionais();
  },
};
</script>
<style scoped>
.card-body {
  font-size: 14px;
  font-weight: 400;
}
.div_cards {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1em;
  margin-bottom: 2em;
}
.div_cards div {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 0.1em 1.5em;
  /* flex-grow: 1; */
  width: 20%;
  position: relative;
}
.div-cards-value-evolution {
  width: 50% !important;
  height: 17vh;
  cursor: pointer;
  display: flex !important;
  place-content: center;
  overflow: hidden;
}

#rec {
  background-color: #203864 !important;
  width: 2px !important;
  position: absolute;
  left: 0px;
  bottom: 0px;
  padding: 6px;
  height: 80%;
}
.title {
  font-size: 25px;
  color: #666;
  transition: all 0.4s;
  font-weight: 600;
}

@media (max-width: 1700px) {
 fieldset .extra-info-title {
    font-size: 26px;
  }
}

@media (max-width: 1400px) {
 fieldset .extra-info-title {
    font-size: 18px;
  }
  .title {
    font-size: 14px;
    color: #666;
  }
}
.div-checkbox-options {
  padding-left: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
fieldset {
  position: absolute;
  text-align: center;
}
fieldset .extra-info-title {
  font-weight: 600;
  font-size: 25px;
}
</style>
